export type ChargeGradeThresholdSetting = {
  id: number
  name: string // このグレードのしきい値帯の名称
  thresholdMasterId: number // このグレードのしきい値が属するグレードのしきい値設定のID
  gradeId: number // このグレード帯域がどのグレードに属するか
  highAmountRange: number // このグレードのしきい値の最高金額
  lowAmountRange: number // このグレードのしきい値の最低金額
  statusIconUrl: string // このグレードのアイコンURL
  backgroundImageUrl: string // このグレードの背景画像URL
  upgradeText: string // このグレードに到達した際のアップグレードテキスト
  prizeDetailUrl: string // このグレードの報酬詳細ページURL
  isMin: boolean // このグレード帯が最も低いかどうか
  isMax: boolean // このグレード帯が最も高いかどうか
}

export type ChargeGradeThresholdSettings = ChargeGradeThresholdSetting[]

export type ChargeGradePrizeSetting = {
  id: number
  masterId: number // この報酬が設定されているグレードマスターのID
  thresholdSettingId: number // このランク報酬が受け取れるランク設定のID
  prizeType: number // ランク報酬の種別
  prizeIconUrl: string // ランク報酬のアイコンURL
  name: string // ランク報酬の名前
  prizeText: string // ランク報酬の表示テキスト
  prizeDescriptionText: string // ランク報酬の詳細説明テキスト
}

export type ChargeGradePrizeSettings = ChargeGradePrizeSetting[]

export enum ChargeGradePrizeType {
  Present = 1, // プレゼント機能によるプレゼント
  CoinPurchaseBonus = 2, // 次月コイン増量
  AdditionalAvatarSlot = 3, // アバタースロット追加
  ViewGradeStatus = 4, // グレード表示機能
}

export type ChargeGrade = {
  chargeGradeMasterId: number
  totalChargeGradeAmount: number
  prizeDetailUrl: string
  currentThresholdSettings: ChargeGradeThresholdSettings
  vipPointInfo: ChargeGradeVipPointInfo | null
}

export type CoinPurchaseBonus = {
  vliveId: string // VliveID
  rate: number // 次月コイン増量の場合の増量率
  remainingTimes: number // 次月コイン増量の場合の残り適用回数(基本初回のみなので1)
  startAt: Date // 開始日時
  endAt: Date // 終了日時
  canPurchaseBonusProduct: boolean // 適用可能かどうか（サーバー側で判断）
  purchaseInProgress: boolean // 購入が進行中かどうか（サーバー側で判断）
}

export type ChargeGradeVipPointInfo = {
  vliveId: string // VliveID
  issuedAt: string // 発行日時
  expiredAt: string // 有効期限
  total: number // ポイント
}

// VIPポイント履歴のVIPショップ詳細
export type ChargeGradeVipPointHistoryVipShopDetail = {
  itemId: number // VIPショップのアイテムID
}

// VIPポイント履歴のプレゼント詳細
export type ChargeGradeVipPointHistoryPresentDetail = {
  presentId: number // プレゼントID
}

// VIPポイント履歴のグレード継続報酬詳細
export type ChargeGradeVipPointHistoryGradeContinuousDetail = {
  gradeId: number // グレードID
  count: number // 継続回数
}

// VIPポイント履歴の詳細
export type ChargeGradeVipPointHistoryDetail = {
  vipShopDetail?: ChargeGradeVipPointHistoryVipShopDetail // VIPショップでの消費の詳細
  presentDetail?: ChargeGradeVipPointHistoryPresentDetail // プレゼントによる付与の詳細
  gradeContinuousDetail?: ChargeGradeVipPointHistoryGradeContinuousDetail // グレード継続報酬の詳細
}

// VIPポイント履歴
export type ChargeGradeVipPointHistory = {
  id: number
  vliveId: string
  value: number
  entryType: number
  entryName: string
  chargeGradeMasterId: number
  details?: ChargeGradeVipPointHistoryDetail
  createdAt: Date
  updatedAt: Date
}

// VIPポイント履歴の配列型
export type ChargeGradeVipPointHistories = ChargeGradeVipPointHistory[]

// 課金グレード継続回数情報
export type ChargeGradeContinuousCount = {
  gradeId: number // グレードID
  gradeName: string // グレード名
  count: number // 連続達成回数
  lastMasterId: number // 最後に達成したマスターID
  iconUrl: string // グレードのアイコンURL
  badgeUrl: string // グレードのバッジURL
}

// 課金制限（18歳未満の月間課金上限）のマイページ表示用情報
export type WebChargeLimitInfo = {
  maxLimit: number // 月間上限（有償コイン数。日本円と1:1）
  usage: number // 当月利用額（確定+有効予約、有償コイン数）
}
